import { ShiftModalContextType } from 'modals/ShiftModal/ShiftModal.ui.context';
import {
  SendToAgenciesFormSchema,
  SendToAgenciesPostActionType,
} from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesView.types';
import { ORDER_SEND_TO_AGENCIES } from 'constants/endpoints';
import { METHOD_POST } from 'requests';
import { ApiRequestConfigType } from './index.types';

type POST_SendToAgenciesPayloadType = {
  hours_before_start?: string;
  jane_id?: string;
  marketplace_jane_id?: string;
  sourceType?: 'agency' | 'marketplace';
  post_action?: SendToAgenciesPostActionType;
  agency_community_ids?: number[];
  marketplace_community_ids?: number[];
} & URLSearchParams;

function payloadTransformer(values: SendToAgenciesFormSchema): POST_SendToAgenciesPayloadType {
  const sendToAgenciesPayload: Record<string, unknown> = {};

  if (values.specific_time_selection[0] !== 'now')
    sendToAgenciesPayload.hours_before_start = values.specific_time_selection[0];

  if (values.post_action) {
    if (!!values.jane_id) {
      sendToAgenciesPayload.jane_id = values.jane_id;
    }
    if (!!values.marketplace_jane_id) {
      sendToAgenciesPayload.marketplace_jane_id = values.marketplace_jane_id;
    }

    sendToAgenciesPayload.post_action = values.post_action;
  }

  if (values.selectedAgencies.length > 0)
    sendToAgenciesPayload.agency_community_ids = values.selectedAgencies;

  if (values.selectedMarketplaceCommunities.length > 0)
    sendToAgenciesPayload.marketplace_community_ids = values.selectedMarketplaceCommunities;

  return sendToAgenciesPayload as unknown as POST_SendToAgenciesPayloadType;
}

export const API_POST_sendOrderToAgencies = (
  orderId: number,
  sendToAgenciesParameters: SendToAgenciesFormSchema,
): ApiRequestConfigType => {
  const payload = payloadTransformer(sendToAgenciesParameters);
  return {
    __typename: 'LegacyAPI',
    url: ORDER_SEND_TO_AGENCIES(orderId),
    body: payload,
    method: METHOD_POST,
  };
};
